import { render } from "./App.vue?vue&type=template&id=5ead8ad5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5ead8ad5&lang=scss"

import exportComponent from "E:\\4-6 项目\\蚂蚁快捷导航\\navigation\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__